import * as React from 'react';
import { GetMediaUploadLimitsResponseDto } from '../../helper-types/dtos/media/responses/get-media-upload-limits-response-dto';
import { API_RELATIVE_URI } from '../../helper-types/general/consts/api-relative-uri';
import { ApiResponse } from '../../helper-types/general/custom-types/api-response';
import HTTP_CLIENT from './http-client-wrapper';

const DEFAULT_LIMITS: GetMediaUploadLimitsResponseDto = {
    imageMaxBytes: 5 * 1024 * 1024,
    equationImageMaxBytes: 2 * 1024 * 1024,
    audioMaxBytes: 75 * 1024 * 1024,
    videoMaxBytes: 100 * 1024 * 1024,
    bunnyVideoMaxBytes: 500 * 1024 * 1024,
    imageExtensions: ['.jpg', '.jpeg', '.png', '.gif', '.svg', '.bmp', '.tiff', '.webp'],
    audioExtensions: ['.mp3', '.wav', '.ogg', '.m4a', '.aac', '.flac', '.wma'],
    videoExtensions: ['.mp4', '.webm', '.mov', '.avi'],
};

const MediaUploadLimitsContext = React.createContext<GetMediaUploadLimitsResponseDto>(DEFAULT_LIMITS);

export const MediaUploadLimitsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [limits, setLimits] = React.useState<GetMediaUploadLimitsResponseDto>(DEFAULT_LIMITS);

    React.useEffect(() => {
        let cancelled = false;

        HTTP_CLIENT
            .getFromJsonAsync<ApiResponse<GetMediaUploadLimitsResponseDto>>(API_RELATIVE_URI.PUBLIC_MEDIA_UPLOAD_LIMITS)
            .then((response) => {
                if (!cancelled && response.success && response.data) {
                    setLimits(response.data);
                }
            })
            .catch(() => {
                // keep DEFAULT_LIMITS as fallback
            });

        return () => {
            cancelled = true;
        };
    }, []);

    return (
        <MediaUploadLimitsContext.Provider value={limits}>
            {children}
        </MediaUploadLimitsContext.Provider>
    );
};

export const useMediaUploadLimits = () => React.useContext(MediaUploadLimitsContext);
